import { Action } from 'redux';
import { AccessTokenPayload, AuthState } from './types';

export enum SessionActionTypes {
    SET_USER_DATA = 'USER__SET_USER_DATA',
}

export interface SetUserDataAction extends Action<SessionActionTypes.SET_USER_DATA> {
    authState: AuthState;
    accessTokenPayload: AccessTokenPayload;
    delegateCompanyId: string | undefined | null;
}

export type SessionAction =
    SetUserDataAction;
